import { toaster } from '~/components/ui/toaster'

import type { ToastLike, ToastLikeOptions } from '@mangovoice/mango-ui'

export const hotelsToast: ToastLike = {
  create: ({ duration = 5000, closable = true, ...rest }: ToastLikeOptions) => {
    toaster.create({ ...rest, duration, closable })
  },
}
